import { render, staticRenderFns } from "./HistoricalCompanyFilter.vue?vue&type=template&id=f8454010&scoped=true&"
import script from "./HistoricalCompanyFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalCompanyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8454010",
  null
  
)

export default component.exports